import { useState, useCallback } from 'react';

interface UseAltchaReturn {
  altchaPayload: string | null;
  isAltchaVerified: boolean;
  altchaError: string | null;
  handleAltchaVerified: (payload: string) => void;
  handleAltchaError: (error: string) => void;
  resetAltcha: () => void;
}

export const useAltcha = (): UseAltchaReturn => {
  const [altchaPayload, setAltchaPayload] = useState<string | null>(null);
  const [isAltchaVerified, setIsAltchaVerified] = useState(false);
  const [altchaError, setAltchaError] = useState<string | null>(null);

  const handleAltchaVerified = useCallback((payload: string) => {
    setAltchaPayload(payload);
    setIsAltchaVerified(true);
    setAltchaError(null);
  }, []);

  const handleAltchaError = useCallback((error: string) => {
    console.error('ALTCHA error in hook:', error);
    setAltchaError(error);
    setIsAltchaVerified(false);
    setAltchaPayload(null);
  }, []);

  const resetAltcha = useCallback(() => {
    setAltchaPayload(null);
    setIsAltchaVerified(false);
    setAltchaError(null);
  }, []);

  return {
    altchaPayload,
    isAltchaVerified,
    altchaError,
    handleAltchaVerified,
    handleAltchaError,
    resetAltcha
  };
};
